export default "__VITE_PUBLIC_ASSET__7f3c7e76__"